import {
  HandCoins,
  HousePlus,
  Merge,
  Pin,
  RotateCw,
  UserRound,
} from "lucide-react";

export const triggers = {
  Investment: {
    icon: HandCoins,
  },
  AddressChanged: {
    icon: Pin,
  },
  Merger: {
    icon: Merge,
  },
  NewManager: {
    icon: UserRound,
  },
  NewOwner: {
    icon: RotateCw,
  },
  NewProductionUnit: {
    icon: HousePlus,
  },
};
